import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Twitter, Mail, CreditCard, Shield, Truck, HeadphonesIcon } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-neutral-200 mt-12">
      {/* Trust row */}
      <div className="bg-neutral-50 border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="flex items-center gap-3">
            <Truck className="text-[#00847A]" size={32} />
            <div>
              <div className="font-semibold text-sm text-[#262626]">Livraison gratuite</div>
              <div className="text-xs text-[#595959]">Dès 50€ d'achat</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Shield className="text-[#00847A]" size={32} />
            <div>
              <div className="font-semibold text-sm text-[#262626]">Paiement sécurisé</div>
              <div className="text-xs text-[#595959]">3D Secure</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <HeadphonesIcon className="text-[#00847A]" size={32} />
            <div>
              <div className="font-semibold text-sm text-[#262626]">Service client</div>
              <div className="text-xs text-[#595959]">7j/7 par chat</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <CreditCard className="text-[#00847A]" size={32} />
            <div>
              <div className="font-semibold text-sm text-[#262626]">Paiement 3x</div>
              <div className="text-xs text-[#595959]">Sans frais dès 100€</div>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="bg-[#00847A] text-white">
        <div className="max-w-7xl mx-auto px-4 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl font-bold flex items-center gap-2"><Mail /> Recevez nos meilleures offres</h3>
            <p className="text-white/80 mt-1">Inscrivez-vous et profitez de -10% sur votre première commande</p>
          </div>
          <form onSubmit={(e) => e.preventDefault()} className="flex gap-2 w-full md:w-auto">
            <input type="email" placeholder="Votre email" className="px-4 py-3 rounded-full text-[#262626] min-w-[280px] outline-none focus:ring-2 focus:ring-white/50" />
            <button className="bg-[#FF4D4D] hover:bg-[#E63939] text-white font-semibold px-6 py-3 rounded-full">S'inscrire</button>
          </form>
        </div>
      </div>

      {/* Links */}
      <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <h4 className="font-bold text-sm mb-4 text-[#262626]">WorldMarket</h4>
          <ul className="space-y-2 text-sm text-[#595959]">
            <li><Link to="/" className="hover:text-[#00847A]">À propos</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Carrières</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Presse</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Engagements RSE</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">WorldMarket Pro</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-sm mb-4 text-[#262626]">Aide & services</h4>
          <ul className="space-y-2 text-sm text-[#595959]">
            <li><Link to="/" className="hover:text-[#00847A]">Service client</Link></li>
            <li><a href="mailto:nietchus@gmail.com" className="hover:text-[#00847A] flex items-center gap-1.5" data-testid="footer-contact-email"><Mail size={14} /> Nous contacter</a></li>
            <li><Link to="/" className="hover:text-[#00847A]">Suivre ma commande</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Retours & remboursements</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Modes de paiement</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-sm mb-4 text-[#262626]">Vendre sur WorldMarket</h4>
          <ul className="space-y-2 text-sm text-[#595959]">
            <li><Link to="/" className="hover:text-[#00847A]">Devenir vendeur</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Espace vendeur</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Partenariats</Link></li>
            <li><Link to="/" className="hover:text-[#00847A]">Programme affilié</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-sm mb-4 text-[#262626]">Suivez-nous</h4>
          <div className="flex gap-3">
            <a href="#" className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-[#00847A] hover:text-white flex items-center justify-center"><Facebook size={18} /></a>
            <a href="#" className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-[#00847A] hover:text-white flex items-center justify-center"><Instagram size={18} /></a>
            <a href="#" className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-[#00847A] hover:text-white flex items-center justify-center"><Youtube size={18} /></a>
            <a href="#" className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-[#00847A] hover:text-white flex items-center justify-center"><Twitter size={18} /></a>
          </div>
          <h4 className="font-bold text-sm mt-6 mb-3 text-[#262626]">Téléchargez l'app</h4>
          <div className="flex gap-2">
            <div className="px-3 py-2 bg-black text-white text-xs rounded-md">App Store</div>
            <div className="px-3 py-2 bg-black text-white text-xs rounded-md">Google Play</div>
          </div>
        </div>
      </div>

      <div className="border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#595959]">
          <div className="flex items-center gap-4">
            <span>© {new Date().getFullYear()} WorldMarket. Tous droits réservés.</span>
            <a href="mailto:nietchus@gmail.com" className="hover:text-[#00847A] flex items-center gap-1"><Mail size={12} /> nietchus@gmail.com</a>
          </div>
          <div className="flex flex-wrap gap-4">
            <Link to="/" className="hover:text-[#00847A]">CGU</Link>
            <Link to="/" className="hover:text-[#00847A]">CGV</Link>
            <Link to="/" className="hover:text-[#00847A]">Données personnelles</Link>
            <Link to="/" className="hover:text-[#00847A]">Cookies</Link>
            <Link to="/" className="hover:text-[#00847A]">Mentions légales</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
